/* tslint:disable */
/* eslint-disable */
/**
 * Business Portal API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/* tslint:disable */
/* eslint-disable */

/**
* このファイルは自動生成されています。そのためgit管理には含まれません。手動で編集してもdeploy時反映されません。
*/

/**
 * 定額種別 (1:メーター運賃, 2:定額)
 * @export
 * @enum {number}
 */
export enum FixedFareCodeEnum {
    /** メーター運賃 */
    METER_FARE = '1',
    /** 定額 */
    FIXED = '2'
}

/**
 * 定額種別 (1:メーター運賃, 2:定額) の Union 型
 * @export
 * @typedef FixedFareCode
 */
export type FixedFareCode =
  typeof FixedFareCodeEnum[keyof typeof FixedFareCodeEnum];

/**
 * 定額種別 (1:メーター運賃, 2:定額) のラベルマップ
 * @export
 */
export const FixedFareCodeLabels = {
    /**
     * 数値キー: FixedFareCodeEnum.METER_FARE
     * 名前キー:  METER_FARE
     */
    [FixedFareCodeEnum.METER_FARE]: 'メーター運賃',
    METER_FARE:                             'メーター運賃',
    /**
     * 数値キー: FixedFareCodeEnum.FIXED
     * 名前キー:  FIXED
     */
    [FixedFareCodeEnum.FIXED]: '定額',
    FIXED:                             '定額',
} as const;

/**
 * 定額種別 (1:メーター運賃, 2:定額) のラベル Union 型
 * @export
 * @typedef FixedFareCodeLabel
 */
export type FixedFareCodeLabel =
  typeof FixedFareCodeLabels[keyof typeof FixedFareCodeLabels];

/**
 * 定額種別 (1:メーター運賃, 2:定額) のラベル取得関数
 * @export
 * @param { FixedFareCode } value - 列挙体の値
 * @returns { FixedFareCodeLabel } ラベル文字列
 */
export function getFixedFareCodeLabel(
  value: FixedFareCode
): FixedFareCodeLabel {
  return FixedFareCodeLabels[value];
}

/**
 * 定額種別 (1:メーター運賃, 2:定額) のラベル配列を取得する関数
 * @export
 * @param { FixedFareCode[] } values - 列挙体の値配列
 * @returns { FixedFareCodeLabel[] } ラベル文字列配列
 */
export function getFixedFareCodeLabels(values: FixedFareCode[]): FixedFareCodeLabel[] {
  return values.map((value) => getFixedFareCodeLabel(value));
}

/**
 * 定額種別 (1:メーター運賃, 2:定額) のラベル配列
 * @export
 */
export const FixedFareCodeLabelList = [
  'メーター運賃','定額',
] as const;

